import axios from "axios";

const baseURL = window._env_ ? window._env_.REACT_APP_API_PATH : 'localhost';

export const api = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});
